import React from 'react';
import { Phone, Mail, Droplets, Clock, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';

export default function WateringSchedule() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(to bottom, #f9fafb 0%, #ffffff 100%)' }}>
      {/* Navigation */}
      <nav style={{ 
        background: 'rgba(0, 0, 0, 0.95)',
        padding: '1rem 0',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          padding: '0 2rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <Logo size={40} />
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              background: '#7f1d1d',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1rem',
              fontWeight: '500',
              transition: 'background 0.3s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#991b1b'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#7f1d1d'}
          >
            <ArrowLeft size={18} />
            Back to Home
          </button>
        </div>
      </nav>

      {/* Header Section */}
      <div style={{
        background: 'linear-gradient(135deg, #7f1d1d 0%, #57534e 100%)',
        color: 'white',
        padding: '4rem 2rem',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ 
            display: 'inline-flex', 
            alignItems: 'center', 
            gap: '0.5rem',
            background: 'rgba(255,255,255,0.2)',
            padding: '0.5rem 1.5rem',
            borderRadius: '50px',
            marginBottom: '1.5rem'
          }}>
            <Droplets size={20} />
            <span style={{ fontSize: '0.875rem', fontWeight: '600', letterSpacing: '0.1em' }}>
              PLANT CARE GUIDE
            </span>
          </div>
          <h1 style={{ 
            fontSize: '3.5rem', 
            fontWeight: 'bold', 
            marginBottom: '1rem',
            lineHeight: '1.1'
          }}>
            Watering Schedule
          </h1>
          <p style={{ fontSize: '1.25rem', opacity: 0.95, lineHeight: '1.6' }}>
            Professional guidelines to keep your landscape thriving
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: '4rem 2rem' }}>
        
        {/* Watering Schedule Cards */}
        <div style={{ display: 'grid', gap: '2rem', marginBottom: '3rem' }}>
          
          {/* B&B Plant Material */}
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2.5rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '2px solid #e5e7eb'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1.5rem' }}>
              <div style={{
                background: 'linear-gradient(135deg, #7f1d1d 0%, #991b1b 100%)',
                color: 'white',
                width: '60px',
                height: '60px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Droplets size={28} />
              </div>
              <div style={{ flex: 1 }}>
                <h2 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: 'bold', 
                  color: '#7f1d1d',
                  marginBottom: '1rem'
                }}>
                  B&B Plant Material
                </h2>
                <p style={{ 
                  fontSize: '1rem', 
                  color: '#6b7280',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  (Balled and Burlapped)
                </p>
                <div style={{ 
                  background: '#fef3c7',
                  border: '2px solid #fbbf24',
                  borderRadius: '8px',
                  padding: '1.5rem',
                  marginBottom: '1rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                    <Clock size={20} color="#92400e" />
                    <p style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600', color: '#92400e' }}>
                      Once Weekly
                    </p>
                  </div>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#78350f', lineHeight: '1.6' }}>
                    <strong>Duration:</strong> 1 hour
                  </p>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#78350f', lineHeight: '1.6', marginTop: '0.5rem' }}>
                    <strong>Water Flow:</strong> About the size of your pinky (gentle stream)
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Large Plant Material */}
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2.5rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '2px solid #e5e7eb'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1.5rem' }}>
              <div style={{
                background: 'linear-gradient(135deg, #92400e 0%, #b45309 100%)',
                color: 'white',
                width: '60px',
                height: '60px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Droplets size={28} />
              </div>
              <div style={{ flex: 1 }}>
                <h2 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: 'bold', 
                  color: '#92400e',
                  marginBottom: '1rem'
                }}>
                  Large Plant Material (No Established Roots)
                </h2>
                <p style={{ 
                  fontSize: '1rem', 
                  color: '#6b7280',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  In case of drought conditions
                </p>
                <div style={{ 
                  background: '#fee2e2',
                  border: '2px solid #ef4444',
                  borderRadius: '8px',
                  padding: '1.5rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                    <Clock size={20} color="#991b1b" />
                    <p style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600', color: '#991b1b' }}>
                      Twice Weekly (During Drought)
                    </p>
                  </div>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#7f1d1d', lineHeight: '1.6' }}>
                    Extra watering needed until roots establish
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Small Container Material */}
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '2.5rem',
            boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
            border: '2px solid #e5e7eb'
          }}>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1.5rem' }}>
              <div style={{
                background: 'linear-gradient(135deg, #15803d 0%, #16a34a 100%)',
                color: 'white',
                width: '60px',
                height: '60px',
                borderRadius: '12px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}>
                <Droplets size={28} />
              </div>
              <div style={{ flex: 1 }}>
                <h2 style={{ 
                  fontSize: '1.75rem', 
                  fontWeight: 'bold', 
                  color: '#15803d',
                  marginBottom: '1rem'
                }}>
                  Small Container Material
                </h2>
                <p style={{ 
                  fontSize: '1rem', 
                  color: '#6b7280',
                  marginBottom: '1.5rem',
                  lineHeight: '1.6'
                }}>
                  Potted plants and small containers
                </p>
                <div style={{ 
                  background: '#d1fae5',
                  border: '2px solid #10b981',
                  borderRadius: '8px',
                  padding: '1.5rem'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem' }}>
                    <Clock size={20} color="#065f46" />
                    <p style={{ margin: 0, fontSize: '1.125rem', fontWeight: '600', color: '#065f46' }}>
                      Three Times Weekly
                    </p>
                  </div>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#047857', lineHeight: '1.6' }}>
                    <strong>Duration:</strong> 1 minute
                  </p>
                  <p style={{ margin: 0, fontSize: '1rem', color: '#047857', lineHeight: '1.6', marginTop: '0.5rem' }}>
                    <strong>Water Flow:</strong> Full blast
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Notes */}
        <div style={{
          background: 'linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)',
          border: '2px solid #3b82f6',
          borderRadius: '12px',
          padding: '2rem',
          marginTop: '3rem'
        }}>
          <h3 style={{ 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
            color: '#1e40af',
            marginBottom: '1rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}>
            💡 Important Notes
          </h3>
          <ul style={{ 
            margin: 0,
            paddingLeft: '1.5rem',
            color: '#1e3a8a',
            lineHeight: '1.8',
            fontSize: '1rem'
          }}>
            <li>Water early morning or evening to minimize evaporation</li>
            <li>Adjust schedule based on rainfall and seasonal changes</li>
            <li>Check soil moisture before watering - it should be slightly dry</li>
            <li>Newly planted material requires consistent watering until established</li>
          </ul>
        </div>

        {/* Contact Section */}
        <div style={{
          background: 'linear-gradient(135deg, #7f1d1d 0%, #57534e 100%)',
          color: 'white',
          borderRadius: '12px',
          padding: '2.5rem',
          marginTop: '3rem',
          textAlign: 'center'
        }}>
          <h3 style={{ fontSize: '1.75rem', fontWeight: 'bold', marginBottom: '1rem' }}>
            Questions About Your Landscape?
          </h3>
          <p style={{ fontSize: '1.125rem', marginBottom: '2rem', opacity: 0.95 }}>
            Our team is here to help with personalized watering recommendations
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
            <a 
              href="tel:215-534-7848"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: 'white',
                textDecoration: 'none',
                fontSize: '1.125rem',
                fontWeight: '500'
              }}
            >
              <Phone size={20} />
              215-534-7848
            </a>
            <a 
              href="mailto:samuels.p85@hotmail.com"
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                color: 'white',
                textDecoration: 'none',
                fontSize: '1.125rem',
                fontWeight: '500'
              }}
            >
              <Mail size={20} />
              samuels.p85@hotmail.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
